type Tag = {
  tag: 'resetboard' | 'dealcards' | 'dealflop' | 'dealturn' | 'dealriver' | 'evalshowdown'
  description: string
}

export type ResetBoard = Tag & { tag: 'resetboard' }
export type DealCards = Tag & { tag: 'dealcards' }
export type DealFlop = Tag & { tag: 'dealflop' }
export type DealTurn = Tag & { tag: 'dealturn' }
export type DealRiver = Tag & { tag: 'dealriver' }
export type EvalShowdown = Tag & { tag: 'evalshowdown' }

export type BoardAction = ResetBoard | DealCards | DealFlop | DealTurn | DealRiver | EvalShowdown

export class BoardActions {
  public static ResetBoard: ResetBoard = <ResetBoard>{
    tag: 'resetboard'
  }

  public static DealCards: DealCards = <DealCards>{
    tag: 'dealcards'
  }

  public static DealFlop: DealFlop = <DealFlop>{
    tag: 'dealflop'
  }

  public static DealTurn: DealTurn = <DealTurn>{
    tag: 'dealturn'
  }

  public static DealRiver: DealRiver = <DealRiver>{
    tag: 'dealriver'
  }

  public static EvalShowdown: EvalShowdown = <EvalShowdown>{
    tag: 'evalshowdown'
  }

  static isResetBoard(a: BoardAction): a is ResetBoard {
    return a.tag === 'resetboard'
  }

  static isDealCards(a: BoardAction): a is DealCards {
    return a.tag === 'dealcards'
  }

  static isDealFlop(a: BoardAction): a is DealFlop {
    return a.tag === 'dealflop'
  }

  static isDealTurn(a: BoardAction): a is DealTurn {
    return a.tag === 'dealturn'
  }

  static isDealRiver(a: BoardAction): a is DealRiver {
    return a.tag === 'dealriver'
  }

  static isEvalShowdown(a: BoardAction): a is EvalShowdown {
    return a.tag === 'evalshowdown'
  }
}
